import React from 'react';
import $ from 'jquery';
import { eq, find, truncate, sortBy } from 'lodash';
import { useLocation, useRouteMatch } from 'react-router-dom';
import SplitPane from 'react-split-pane';
import { useQuery, useMutation } from '@apollo/client';
import sortByChapter from 'sort-by-chapter';
import removeHtml from '../../util/remove_html_markup';
import constants from '../../constants.json';
import { PageSettings, DeviceBar } from '.';
import Loader from '../loader';

import { SET_CLIENT_STATE, CLIENT_STATE, PAGE_DATA, GENERAL_SETTINGS, PAGE_LIST } from '../../graphqls';
import Live from './live';

export default function Panel() {
  const { pathname } = useLocation();
  const isDrillDownPage = useRouteMatch('/plan_node/');
  const { devices } = constants;
  const paths = pathname.split('/');
  const { loading: loadingClientState, data: { sideMenu, deviceView } = {}, data } = useQuery(CLIENT_STATE);
  const { loading: loadingPageList, data: { pageList = [] } = {} } = useQuery(PAGE_LIST);
  const { loading: loadingPageData, data: { pageData: { cache = {}, cache: { measureId, planNodeId } = {}, ancestor = [] } = {} } = {} } =
    useQuery(PAGE_DATA, { variables: { name: eq(paths[1], 'home') ? 'home' : paths[2] } });
  const { loading: loadingGeneralSettings, data: { generalSettings = {} } = {} } = useQuery(GENERAL_SETTINGS);
  const [setState] = useMutation(SET_CLIENT_STATE);

  const selectedDevice = find(devices, ({ name }) => eq(name, deviceView));
  let deviceDimensionStyle = {};
  let deviceModeClass = '';

  if (selectedDevice.name !== 'desktop') {
    deviceModeClass = 'device-mode';
    deviceDimensionStyle = {
      width: selectedDevice.width,
      overflow: 'auto',
      margin: '0 auto',
      border: 'solid 1px #000',
    };
  }

  const pageArray = JSON.parse(JSON.stringify(pageList));
  const pageObject = {};
  let items = [];

  pageArray.forEach((_, pageIndex) => {
    pageObject[pageArray[pageIndex].planNodeId] = pageIndex;
    pageArray[pageIndex].items = [];
    pageArray[pageIndex].measures = [];
  });
  pageArray.forEach(
    ({
      parentPlanNodeId,
      measureId: itemMeasureId,
      planNodeId: itemPlanNodeId,
      title,
      description,
      numberWithLabel,
      position: order,
      enable,
    }) => {
      if (typeof parentPlanNodeId === 'string' && parentPlanNodeId.length > 0 && enable === true) {
        if (pageArray[pageObject[parentPlanNodeId]]) {
          pageArray[pageObject[parentPlanNodeId]].items.push({
            id: itemPlanNodeId,
            title: title || truncate(removeHtml(description), { separator: ' ', length: 60 }),
            isMeasure: false,
            numberWithLabel,
            items: sortByChapter(pageArray[pageObject[itemPlanNodeId]].items, { attribute: 'numberWithLabel' }),
            measures: pageArray[pageObject[itemPlanNodeId]].measures,
            level: numberWithLabel.split(' ').reverse()[0].split('.').length,
          });
        }
      } else if (itemMeasureId && enable) {
        pageArray[pageObject[itemPlanNodeId]].measures.push({
          id: itemMeasureId,
          title,
          isMeasure: true,
          position: order,
        });
      } else if (parentPlanNodeId === '' && enable === true) {
        items.push({
          id: itemPlanNodeId,
          title: title || truncate(removeHtml(description), { separator: ' ', length: 60 }),
          level: 1,
          isMeasure: false,
          items: sortByChapter(pageArray[pageObject[itemPlanNodeId]].items, { attributes: 'numberWithLabel' }),
          measures: sortBy(pageArray[pageObject[itemPlanNodeId]].measures, ['position']),
          numberWithLabel,
        });
      }
    },
  );

  items = sortByChapter(items, { attribute: 'numberWithLabel' });

  const onChange = (size) => setState({ leftPanelWidth: $('.layout-split-pane-container').width() - size });
  const onDragStarted = () => $('.overlay').css('display', 'block');
  const onDragFinished = () => $('.overlay').css('display', 'none');

  if (loadingClientState || loadingPageData || loadingGeneralSettings || loadingPageList) {
    return <Loader>We&apos;re loading your workspace</Loader>;
  }

  return (
    <SplitPane
      className={`pd-split-pane ${sideMenu === 'pageListView' ? 'slide-right' : 'slide-left'}`}
      split="vertical"
      size="70%"
      primary="second"
      onChange={onChange}
      onDragStarted={onDragStarted}
      onDragFinished={onDragFinished}
    >
      <PageSettings />
      <div className={`site-preview ${deviceModeClass}`}>
        <div className="overlay" />
        <DeviceBar />
        <div className="iframe-overlay">
          <div className="iframe-overlay-secondary">
            <Live
              measureId={measureId}
              planNodeId={planNodeId}
              ancestor={ancestor}
              deviceDimensionStyle={deviceDimensionStyle}
              isDrillDownPage={isDrillDownPage}
              cache={cache}
              generalSettings={generalSettings}
              items={items}
            />
          </div>
        </div>
      </div>
    </SplitPane>
  );
}
